import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootLayout } from './ui/components/RootLayout';
import { HomePage } from './ui/pages/HomePage';
import { MatchmakingPage } from './ui/pages/MatchmakingPage';
import { RoomPage } from './ui/pages/RoomPage';
import { ResultsPage } from './ui/pages/ResultsPage';
import { WalletPage } from './ui/pages/WalletPage';
import { SettingsPage } from './ui/pages/SettingsPage';
import { PracticeModePage } from './ui/pages/PracticeModePage';
import { PracticeMatchPage } from './ui/pages/PracticeMatchPage';
import { InfoPage } from './ui/pages/InfoPage';
import { FAQPage } from './ui/pages/FAQPage';
import { LeaderboardPage } from './ui/pages/LeaderboardPage';
import { TournamentPage } from './ui/pages/TournamentPage';
// ReferralPage consolidated into Social page
import { FriendsPage } from './ui/pages/FriendsPage';
import { TrophyRoomPage } from './ui/pages/TrophyRoomPage';
import { SpectatorPage } from './ui/pages/SpectatorPage';
import { TutorialPage } from './ui/pages/TutorialPage';
import { TutorialMatchPage } from './ui/pages/TutorialMatchPage';
import { ReplayPage } from './ui/pages/ReplayPage';
import { SwapPage } from './ui/pages/SwapPage';
import { SeasonsPage } from './ui/pages/SeasonsPage';
import { StakingPage } from './ui/pages/StakingPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'matchmaking', element: <MatchmakingPage /> },
      { path: 'room/:matchId', element: <RoomPage /> },
      { path: 'results/:matchId', element: <ResultsPage /> },
      { path: 'wallet', element: <WalletPage /> },
      { path: 'swap', element: <SwapPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'practice', element: <PracticeModePage /> },
      { path: 'practice/match', element: <PracticeMatchPage /> },
      { path: 'info', element: <InfoPage /> },
      { path: 'faq', element: <FAQPage /> },
      { path: 'run', element: <Navigate to="/info" replace /> },
      { path: 'leaderboard', element: <LeaderboardPage /> },
      { path: 'seasons', element: <SeasonsPage /> },
      { path: 'staking', element: <StakingPage /> },
      { path: 'tournaments', element: <TournamentPage /> },
      { path: 'tournaments/:id', element: <TournamentPage /> },
      { path: 'referral', element: <Navigate to="/friends" replace /> },
      { path: 'friends', element: <FriendsPage /> },
      { path: 'trophies', element: <TrophyRoomPage /> },
      { path: 'spectate', element: <SpectatorPage /> },
      { path: 'tutorial', element: <TutorialPage /> },
      { path: 'tutorial/match', element: <TutorialMatchPage /> },
      { path: 'replays', element: <ReplayPage /> },
      { path: 'replays/:matchId', element: <ReplayPage /> },
      { path: 'history', element: <Navigate to="/leaderboard" replace /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

export default router;
